<template>
<div>
    <base-table>
            <!--      <base-table @refetch-companies="fetchNewCompanies">-->
            <template #table-header>
              <base-table-header :key="header.id" :header="header" v-for="header in tableHeadersList"> {{
                  header
                }}
              </base-table-header>
            </template>
  
            <template #table-body>
              <ConfigurableCompanyRow
                :company="testCompany"
                :campaigns="campaigns"
                :permissions="userPermissions"
                :page-config="previewConfig"
                :crm-statuses="crmStatuses"
                :selectAll="selectAll"
                :selectAllOnPage="selectAllOnPage"
                :selectedCompaniesOnPageMap="selectedCompaniesOnPageMap"
                :clearedSelectedCompanies="clearedSelectedCompanies"
                :clearedSelectedCompaniesOnPage="clearedSelectedCompaniesOnPage"
                :changedCompanyFilters="changedCompanyFilters"
                          />
            </template>
          </base-table>
</div>
</template>

<script>
export default {
    name: "company-preview-table"
}
</script>

<script setup>
import ConfigurableCompanyRow from './ConfigurableCompanyRow.vue';
import { defineProps, ref, computed, shallowReactive } from 'vue';
import {useStore} from 'vuex';
import { getCampaigns } from '@/services/Campaign';
import { getCrmStatuses } from '@/services/CrmStatus';

const store = useStore()

const companyResults = ref([]);
const next = ref(null);
const prev = ref(null);
const count = ref(null);
const page = ref(null);
const pageSize = ref(null);
const changedCompanyFilters = ref(false);
const isModalVisible = ref(false);
const selectedCompanies = ref([]);
const selectAll = ref(false);
const selectAllOnPage = ref(false);
const clearedSelectedCompanies = ref(false);
const clearedSelectedCompaniesOnPage = ref(false);
const awaitingSearch = ref(false);

 const testCompany = ref({
    "id": 100245,
    "company_name": "AA Test Company Tres Test!!!!!!",
    "website_url": "http://www.apple.com",
    "campaign": {
        "id": 25,
        "campaign_name": "New fake campaign",
        "status": "inactive"
    },
    "city": "Cupertino",
    "state": "California",
    "address": "1 Apple Park Way",
    "country": "United States",
    "url_vetted_by": null,
    "sources": [
        {
            "id": 1,
            "source_name": "Test Source One"
        }
    ],
    "research_complete": -1,
    "revenue": "387537.00",
    "revenue_last_updated_date": null,
    "revenue_source": "ZoomInfo",
    "employee_headcount": 154000,
    "zi_revenue": "387537000.00",
    "zi_employee_headcount": 154000,
    "crm_status": "Hold",
    "crm_next_action": "Wait on Response",
    "doing_business_as": "test company tFour",
    "zi_company_name": "Apple",
    "status": "active",
    "onboarding_status": "imported",
    "parent_company": "test!",
    "investors": "test!",
    "zi_address": "1 Apple Park Way",
    "zi_city": "Cupertino",
    "zi_state": "California",
    "zip": "95014",
    "zi_zip": "95014",
    "lat": null,
    "long": null,
    "square_footage": "40.0",
    "distance_to": "0.00",
    "driving_time": "0.00",
    "alternate_addresses": "test er test",
    "phone": "(408) 996-1010",
    "zi_phone": "(408) 996-1010",
    "ebitda": "4.00",
    "business_type": [],
    "sector": [],
    "sub_sector": [],
    "source_owner": null,
    "acquirer": "tester",
    "description": "Headquartered in Cupertino, California, Apple Inc. is a multinational technology company that designs, develops and sells consumer electronics, computer software, and online services.",
    "account_manager_research_notes": "Account manager research notes go here!!! More notes go here",
    "further_research_needed": "test research Okay",
    "client_feedback_notes": "test Hey",
    "client_feedback": null,
    "customers": "boom boom",
    "platforms": "test platform notes",
    "previous_tier": "tier_2",
    "tier_last_updated_date": "2023-02-07T12:09:02.330158-06:00",
    "merge_conflicts": "**COMPANY_NAME CONFLICT WITH COMPANY 100251**: \r\n AA Test Company Cinco! \r\n **MERGE_CONFLICTS CONFLICT WITH COMPANY 100251**: \r\n **COMPANY_NAME CONFLICT WITH COMPANY 100332**: \r\n aa test company seis \r\n **VETTED_URL_DT CONFLICT WITH COMPANY 100332**: \r\n 2022-12-15 19:39:35.109084+00:00 \r\n **DESCRIPTION CONFLICT WITH COMPANY 94896**: \r\n test company two \r\n **ADDRESS CONFLICT WITH COMPANY 94896**: \r\n 123 Main St \r\n **CITY CONFLICT WITH COMPANY 94896**: \r\n Chicago \r\n **STATE CONFLICT WITH COMPANY 94896**: \r\n IL \r\n **ZIP CONFLICT WITH COMPANY 94896**: \r\n 60647 \r\n **COMPANY_NAME CONFLICT WITH COMPANY 94896**: \r\n AA Test Company Two \r\n **DESCRIPTION CONFLICT WITH COMPANY 94896**: \r\n test company two \r\n **OUT_REACH_FULL_NAME CONFLICT WITH COMPANY 94896**: \r\n test \r\n **OUT_REACH_TITLE CONFLICT WITH COMPANY 94896**: \r\n test test \r\n **SOURCE_OWNER CONFLICT WITH COMPANY 94896**: \r\n Unassigned \r\n **VETTED_URL_DT CONFLICT WITH COMPANY 94896**: \r\n 2022-12-15 22:07:16.868652+00:00 \r\n **COMPANY_NAME CONFLICT WITH COMPANY 100333**: \r\n aa test company seis \r\n **VETTED_URL_DT CONFLICT WITH COMPANY 100333**: \r\n 2022-12-15 22:41:04.945078+00:00 \r\n **COMPANY_NAME CONFLICT WITH COMPANY 100334**: \r\n aa test company seis \r\n **VETTED_URL_DT CONFLICT WITH COMPANY 100334**: \r\n 2022-12-15 22:45:24.571337+00:00 \r\n **COMPANY_NAME CONFLICT WITH COMPANY 100335**: \r\n aa test company seis \r\n **VETTED_URL_DT CONFLICT WITH COMPANY 100335**: \r\n 2022-12-15 22:47:58.721591+00:00 \r\n **COMPANY_NAME CONFLICT WITH COMPANY 100336**: \r\n aa test company seis \r\n **MERGE_CONFLICTS CONFLICT WITH COMPANY 100336**: \r\n **COMPANY_NAME CONFLICT WITH COMPANY 100337**: \r\n AA TEST 7 \r\n **VETTED_URL_DT CONFLICT WITH COMPANY 100337**: \r\n 2022-12-16 16:01:56.064056+00:00 \r\n **VETTED_URL_DT CONFLICT WITH COMPANY 100336**: \r\n 2022-12-16 16:01:55.668294+00:00 \r\n --MERGE CONFLICTS ASSIMILATED FROM 100336-- \r\n **COMPANY_NAME CONFLICT WITH COMPANY 100337**: \r\n AA TEST 7 \r\n **VETTED_URL_DT CONFLICT WITH COMPANY 100337**: \r\n 2022-12-16 16:01:56.064056+00:00 \r\n **COMPANY_NAME CONFLICT WITH COMPANY 100338**: \r\n AA Test Company Seis \r\n **VETTED_URL_DT CONFLICT WITH COMPANY 100338**: \r\n 2022-12-16 19:30:34.474974+00:00 \r\n **SOURCE_OWNER CONFLICT WITH COMPANY 100251**: \r\n Patrick Alvarez \r\n **VETTED_URL_DT CONFLICT WITH COMPANY 100251**: \r\n 2022-12-16 19:32:32.595989+00:00 \r\n --MERGE CONFLICTS ASSIMILATED FROM 100251-- \r\n **COMPANY_NAME CONFLICT WITH COMPANY 100332**: \r\n aa test company seis \r\n **VETTED_URL_DT CONFLICT WITH COMPANY 100332**: \r\n 2022-12-15 19:39:35.109084+00:00 \r\n **DESCRIPTION CONFLICT WITH COMPANY 94896**: \r\n test company two \r\n **ADDRESS CONFLICT WITH COMPANY 94896**: \r\n 123 Main St \r\n **CITY CONFLICT WITH COMPANY 94896**: \r\n Chicago \r\n **STATE CONFLICT WITH COMPANY 94896**: \r\n IL \r\n **ZIP CONFLICT WITH COMPANY 94896**: \r\n 60647 \r\n **COMPANY_NAME CONFLICT WITH COMPANY 94896**: \r\n AA Test Company Two \r\n **DESCRIPTION CONFLICT WITH COMPANY 94896**: \r\n test company two \r\n **OUT_REACH_FULL_NAME CONFLICT WITH COMPANY 94896**: \r\n test \r\n **OUT_REACH_TITLE CONFLICT WITH COMPANY 94896**: \r\n test test \r\n **SOURCE_OWNER CONFLICT WITH COMPANY 94896**: \r\n Unassigned \r\n **VETTED_URL_DT CONFLICT WITH COMPANY 94896**: \r\n 2022-12-15 22:07:16.868652+00:00 \r\n **COMPANY_NAME CONFLICT WITH COMPANY 100333**: \r\n aa test company seis \r\n **VETTED_URL_DT CONFLICT WITH COMPANY 100333**: \r\n 2022-12-15 22:41:04.945078+00:00 \r\n **COMPANY_NAME CONFLICT WITH COMPANY 100334**: \r\n aa test company seis \r\n **VETTED_URL_DT CONFLICT WITH COMPANY 100334**: \r\n 2022-12-15 22:45:24.571337+00:00 \r\n **COMPANY_NAME CONFLICT WITH COMPANY 100335**: \r\n aa test company seis \r\n **VETTED_URL_DT CONFLICT WITH COMPANY 100335**: \r\n 2022-12-15 22:47:58.721591+00:00 \r\n **COMPANY_NAME CONFLICT WITH COMPANY 100336**: \r\n aa test company seis \r\n **MERGE_CONFLICTS CONFLICT WITH COMPANY 100336**: \r\n **COMPANY_NAME CONFLICT WITH COMPANY 100337**: \r\n AA TEST 7 \r\n **VETTED_URL_DT CONFLICT WITH COMPANY 100337**: \r\n 2022-12-16 16:01:56.064056+00:00 \r\n **VETTED_URL_DT CONFLICT WITH COMPANY 100336**: \r\n 2022-12-16 16:01:55.668294+00:00 \r\n --MERGE CONFLICTS ASSIMILATED FROM 100336-- \r\n **COMPANY_NAME CONFLICT WITH COMPANY 100337**: \r\n AA TEST 7 \r\n **VETTED_URL_DT CONFLICT WITH COMPANY 100337**: \r\n 2022-12-16 16:01:56.064056+00:00 \r\n **COMPANY_NAME CONFLICT WITH COMPANY 100338**: \r\n AA Test Company Seis \r\n **VETTED_URL_DT CONFLICT WITH COMPANY 100338**: \r\n 2022-12-16 19:30:34.474974+00:00 \r\n **TIER CONFLICT WITH COMPANY 100251**: \r\n tier_1 \r\n **COMPANY_NAME CONFLICT WITH COMPANY 100348**: \r\n AA Test Seis \r\n **VETTED_URL_DT CONFLICT WITH COMPANY 100348**: \r\n 2023-01-17 21:56:24.137715+00:00",
    "acquisition_date": "2021-12-12",
    "reason_cannot_acquire": "Client",
    "archive_reason": null,
    "duplicate_uuid": null,
    "crm_summary": "test summary here is the test Not Null",
    "out_reach_notes": "test notes are going hereare some more ones here is an outreach note here is another note",
    "crm_emails": [],
    "zoom_info_id": 2441797,
    "do_not_research_reason": null,
    "tier_object": {
        "id": 3,
        "tier_name": "tier_3"
    },
    "zi_website_url": "www.apple.com",
    "crm_next_action_due_date": "2023-02-14",
    "crm_activity_outcome": "Test Save.",
    "collection_tags": [],
    "crm_statuses": [
        {
            "id": 11,
            "crm_status": {
                "high_level_grouping_for_report": {
                    "id": 5,
                    "high_level_grouping_name": "No Response"
                },
                "id": 3,
                "status_name": "No Response"
            },
            "campaign": {
                "id": 17,
                "campaign_name": "Test-Campaign-Not-Real",
                "status": "active"
            },
            "created_on": "2023-03-29T14:20:53.462674-05:00"
        },
        {
            "id": 10,
            "crm_status": {
                "high_level_grouping_for_report": {
                    "id": 1,
                    "high_level_grouping_name": "Moving Forward On"
                },
                "id": 2,
                "status_name": "High Priority (Continue in Process)"
            },
            "campaign": {
                "id": 17,
                "campaign_name": "Test-Campaign-Not-Real",
                "status": "active"
            },
            "created_on": "2023-03-29T14:18:14.662680-05:00"
        },
        {
            "id": 2,
            "crm_status": {
                "high_level_grouping_for_report": {
                    "id": 4,
                    "high_level_grouping_name": "Target is Not Interested / Client Pass"
                },
                "id": 1,
                "status_name": "Client Pass"
            },
            "campaign": {
                "id": 17,
                "campaign_name": "Test-Campaign-Not-Real",
                "status": "active"
            },
            "created_on": "2023-02-28T09:52:04.052000-06:00"
        },
        {
            "id": 1,
            "crm_status": {
                "high_level_grouping_for_report": {
                    "id": 1,
                    "high_level_grouping_name": "Moving Forward On"
                },
                "id": 2,
                "status_name": "High Priority (Continue in Process)"
            },
            "campaign": {
                "id": 17,
                "campaign_name": "Test-Campaign-Not-Real",
                "status": "active"
            },
            "created_on": "2023-02-28T03:51:16.978000-06:00"
        },
        {
            "id": 18,
            "crm_status": {
                "high_level_grouping_for_report": {
                    "id": 4,
                    "high_level_grouping_name": "Target is Not Interested / Client Pass"
                },
                "id": 1,
                "status_name": "Client Pass"
            },
            "campaign": {
                "id": 25,
                "campaign_name": "New fake campaign",
                "status": "inactive"
            },
            "created_on": "2023-03-30T11:27:32.830630-05:00"
        },
        {
            "id": 17,
            "crm_status": {
                "high_level_grouping_for_report": {
                    "id": 5,
                    "high_level_grouping_name": "No Response"
                },
                "id": 3,
                "status_name": "No Response"
            },
            "campaign": {
                "id": 25,
                "campaign_name": "New fake campaign",
                "status": "inactive"
            },
            "created_on": "2023-03-30T11:25:55.701134-05:00"
        },
        {
            "id": 16,
            "crm_status": {
                "high_level_grouping_for_report": {
                    "id": 1,
                    "high_level_grouping_name": "Moving Forward On"
                },
                "id": 2,
                "status_name": "High Priority (Continue in Process)"
            },
            "campaign": {
                "id": 25,
                "campaign_name": "New fake campaign",
                "status": "inactive"
            },
            "created_on": "2023-03-30T11:17:03.448661-05:00"
        },
        {
            "id": 15,
            "crm_status": {
                "high_level_grouping_for_report": {
                    "id": 4,
                    "high_level_grouping_name": "Target is Not Interested / Client Pass"
                },
                "id": 1,
                "status_name": "Client Pass"
            },
            "campaign": {
                "id": 25,
                "campaign_name": "New fake campaign",
                "status": "inactive"
            },
            "created_on": "2023-03-30T11:15:37.261435-05:00"
        },
        {
            "id": 14,
            "crm_status": {
                "high_level_grouping_for_report": {
                    "id": 1,
                    "high_level_grouping_name": "Moving Forward On"
                },
                "id": 2,
                "status_name": "High Priority (Continue in Process)"
            },
            "campaign": {
                "id": 25,
                "campaign_name": "New fake campaign",
                "status": "inactive"
            },
            "created_on": "2023-03-30T09:38:27.157874-05:00"
        },
        {
            "id": 13,
            "crm_status": {
                "high_level_grouping_for_report": {
                    "id": 4,
                    "high_level_grouping_name": "Target is Not Interested / Client Pass"
                },
                "id": 1,
                "status_name": "Client Pass"
            },
            "campaign": {
                "id": 25,
                "campaign_name": "New fake campaign",
                "status": "inactive"
            },
            "created_on": "2023-03-30T09:38:19.216581-05:00"
        },
        {
            "id": 12,
            "crm_status": {
                "high_level_grouping_for_report": {
                    "id": 5,
                    "high_level_grouping_name": "No Response"
                },
                "id": 3,
                "status_name": "No Response"
            },
            "campaign": {
                "id": 25,
                "campaign_name": "New fake campaign",
                "status": "inactive"
            },
            "created_on": "2023-03-30T09:16:26.119148-05:00"
        },
        {
            "id": 9,
            "crm_status": {
                "high_level_grouping_for_report": {
                    "id": 4,
                    "high_level_grouping_name": "Target is Not Interested / Client Pass"
                },
                "id": 1,
                "status_name": "Client Pass"
            },
            "campaign": {
                "id": 25,
                "campaign_name": "New fake campaign",
                "status": "inactive"
            },
            "created_on": "2023-03-29T08:23:06.256473-05:00"
        },
        {
            "id": 8,
            "crm_status": {
                "high_level_grouping_for_report": {
                    "id": 1,
                    "high_level_grouping_name": "Moving Forward On"
                },
                "id": 2,
                "status_name": "High Priority (Continue in Process)"
            },
            "campaign": {
                "id": 25,
                "campaign_name": "New fake campaign",
                "status": "inactive"
            },
            "created_on": "2023-03-29T08:21:06.900970-05:00"
        },
        {
            "id": 7,
            "crm_status": {
                "high_level_grouping_for_report": {
                    "id": 4,
                    "high_level_grouping_name": "Target is Not Interested / Client Pass"
                },
                "id": 1,
                "status_name": "Client Pass"
            },
            "campaign": {
                "id": 25,
                "campaign_name": "New fake campaign",
                "status": "inactive"
            },
            "created_on": "2023-03-28T17:01:50.979978-05:00"
        },
        {
            "id": 6,
            "crm_status": {
                "high_level_grouping_for_report": {
                    "id": 1,
                    "high_level_grouping_name": "Moving Forward On"
                },
                "id": 2,
                "status_name": "High Priority (Continue in Process)"
            },
            "campaign": {
                "id": 25,
                "campaign_name": "New fake campaign",
                "status": "inactive"
            },
            "created_on": "2023-03-28T16:57:14.293168-05:00"
        },
        {
            "id": 5,
            "crm_status": {
                "high_level_grouping_for_report": {
                    "id": 4,
                    "high_level_grouping_name": "Target is Not Interested / Client Pass"
                },
                "id": 1,
                "status_name": "Client Pass"
            },
            "campaign": {
                "id": 25,
                "campaign_name": "New fake campaign",
                "status": "inactive"
            },
            "created_on": "2023-03-28T16:52:20.214387-05:00"
        },
        {
            "id": 4,
            "crm_status": {
                "high_level_grouping_for_report": {
                    "id": 5,
                    "high_level_grouping_name": "No Response"
                },
                "id": 3,
                "status_name": "No Response"
            },
            "campaign": {
                "id": 25,
                "campaign_name": "New fake campaign",
                "status": "inactive"
            },
            "created_on": "2023-03-28T15:39:30.331993-05:00"
        }
    ],
    "crm_actions": [
        {
            "id": 5,
            "campaign": {
                "id": 17,
                "campaign_name": "Test-Campaign-Not-Real",
                "status": "active"
            },
            "action_name": "Send Initial Email",
            "status": "Open",
            "action_notes": "Reach out with question about revenue",
            "action_details": null,
            "is_milestone": null,
            "due_date": "2023-03-31",
            "resolved_date": null,
            "created_at": "2023-03-30"
        },
        {
            "id": 4,
            "campaign": {
                "id": 25,
                "campaign_name": "New fake campaign",
                "status": "inactive"
            },
            "action_name": "Meet with Contact at Expo",
            "status": "Open",
            "action_notes": "Meet with the test contact at the heliotrope expo",
            "action_details": null,
            "is_milestone": null,
            "due_date": "2023-04-13",
            "resolved_date": null,
            "created_at": "2023-03-29"
        },
        {
            "id": 3,
            "campaign": {
                "id": 25,
                "campaign_name": "New fake campaign",
                "status": "inactive"
            },
            "action_name": "Send followup email",
            "status": "Open",
            "action_notes": "Followup on initial offer",
            "action_details": null,
            "is_milestone": null,
            "due_date": "2023-04-04",
            "resolved_date": null,
            "created_at": "2023-03-29"
        },
        {
            "id": 2,
            "campaign": {
                "id": 25,
                "campaign_name": "New fake campaign",
                "status": "inactive"
            },
            "action_name": "Send Initial Email",
            "status": "Done",
            "action_notes": "Reach out to Test Contact 1 about potentially acquiring the business",
            "action_details": "Sample email body: \nLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
            "is_milestone": null,
            "due_date": "2023-03-31",
            "resolved_date": "2023-03-29",
            "created_at": "2023-03-29"
        }
    ],
    "contacts": [
        {
            "id": 150224,
            "first_name": "Test",
            "last_name": "Contact 1",
            "title": "Test CEO",
            "email": "test@test.com",
            "phone": "1234567897",
            "notes": "Test contact notes for testing",
            "is_primary_contact": true,
            "linkedin_profile": null
        },
        {
            "id": 150225,
            "first_name": "Test",
            "last_name": "Contact 2",
            "title": "Test Vice President",
            "email": "test2@test.com",
            "phone": "3053452212",
            "notes": "Ignore this person, not even worth talking about basically a nobody",
            "is_primary_contact": false,
            "linkedin_profile": "https://www.linkedin.com/in/patrick-g-alvarez/"
        }
    ],
    "activities": [],
    "raw_address": null,
    "positiondelta_set": []
})

const props = defineProps({
    cellList: Array
})

const campaigns = ref([])
const crmStatuses = ref([])
const userPermissions = shallowReactive({
    isManagement: null,
    isHourly: null,
    isStudent: null,
    isResearch: null,
    isAdvancedResearch: null,
    isSuperuser: null,
    isAccountManager: null,
    isAccountStaff: null,
    isDev: null,
    isResearchLead: null,
    isAllCompanies: null,
    isGenerateTimecard: null,
  });

const previewConfig = computed(() => {
    const preveiew = {cells: props.cellList}
    console.log('preview in table', preveiew)
    return {cells: props.cellList}
})

const tableHeadersList = computed(() => {
    const headers = ['', 'ID', ...props.cellList.map(cell => cell.company_cell.column_header)]
    // console.log('headers', headers)
    return headers
})

async function loadCampaigns(){
    const token = store.state.auth.token
    const result = await getCampaigns(token)
    campaigns.value = result
  }

async function loadCrmStatuses(){
const token = store.state.auth.token
const result = await getCrmStatuses(token)
crmStatuses.value = result
}

const selectedCompanyIds = computed(function() {
  if(selectedCompanies.value.length > 0){
    return selectedCompanies.value.map(({id}) => {
      return id
    })

  } else {
    return []
  }
})

const companyResultsIds = computed(function() {
  if(companyResults.value.length > 0){
    return companyResults.value.map(({id}) => {
      return id
    })
  } else {
    return []
  }
})

const numSelectedCompanies = computed(function() {
  return selectedCompanies.value.length
})

const selectedCompaniesOnPage = computed(function() {
  if(numSelectedCompanies.value > 0){
    return selectedCompanyIds.value.filter((companyId) => {
      return companyResultsIds.value.includes(companyId)
  })
  } else {
    return []
  }
})

const selectedCompaniesOnPageMap = computed(function() {
  return new Map(selectedCompaniesOnPage.value.map((companyId) => [companyId, companyId]))
})

const setUserPermissions = function () {
    let userPermissionsStore = store.getters['auth/showUserPermissions']
    // console.log('user permissions store', userPermissionsStore)
    userPermissions.isManagement = userPermissionsStore.isManagement
    userPermissions.isHourly = userPermissionsStore.isHourly
    userPermissions.isStudent =  userPermissionsStore.isStudent
    userPermissions.isResearch =  userPermissionsStore.isResearch
    userPermissions.isAdvancedResearch =  userPermissionsStore.isAdvancedResearch
    userPermissions.isSuperuser =  userPermissionsStore.isSuperuser
    userPermissions.isAccountManager =  userPermissionsStore.isAccountManager
    userPermissions.isAccountStaff =  userPermissionsStore.isAccountStaff
    userPermissions.isDev =  userPermissionsStore.isDev
    userPermissions.isResearchLead =  userPermissionsStore.isResearchLead
    userPermissions.isAllCompanies =  userPermissionsStore.isAllCompanies
    userPermissions.isGenerateTimecard =  userPermissionsStore.isGenerateTimecard
  
    // console.log('user permissions', userPermissions)
  }

loadCampaigns()
loadCrmStatuses()
setUserPermissions()

</script>